import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const getSkillAgentMoodboardsMeta = async () => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/meta`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const listSkillAgentMoodboards = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-moodboards`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillAgentMoodboardById = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const createSkillAgentMoodboard = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateSkillAgentMoodboard = async (id, payload) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-moodboards/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteSkillAgentMoodboard = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-moodboards/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const getSkillAgentMoodboardPool = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/${id}/pool`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const addSkillAgentMoodboardAssets = async (
  id,
  { searchItemIds = [], files = [] } = {},
) => {
  const form = new FormData();
  if (searchItemIds.length) {
    form.append("searchItemIds", JSON.stringify(searchItemIds));
  }
  for (const f of files) {
    form.append("files", f);
  }
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/assets`,
    form,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const deleteSkillAgentMoodboardAsset = async (id, assetId) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-moodboards/${id}/assets/${assetId}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const saveSkillAgentMoodboardPages = async (id, pages) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-moodboards/${id}/pages`,
    { PagesJson: pages },
    { headers: authHeaders() },
  );
  return response.data;
};

export const autoSkillAgentMoodboardPages = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/pages/auto`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const exportSkillAgentMoodboardPdf = async (id, body = {}) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-moodboards/${id}/export-pdf`,
    body,
    { headers: authHeaders(), timeout: 180000 },
  );
  return response.data;
};

export const fetchSkillAgentMoodboardAssetBlobUrl = async (assetId) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-moodboards/assets/${assetId}/file`,
    { headers: authHeaders(), responseType: "blob" },
  );
  return URL.createObjectURL(response.data);
};
